import { T } from "@/locales";

export default [
  {
    title: T("序号"),
    dataIndex: "index",
    fixed: "left",
    width: 60,
    customRender: (value, item, index) => index + 1,
  },
  {
    title: T("货主"),
    dataIndex: "client_name",
    fixed: "left",
    width: 120,
    ellipsis: true,
  },
  {
    title: T("入库短驳费用(元)"),
    dataIndex: "stock_in_transport_amount",
    width: 180,
    ellipsis: true,
  },
  {
    title: T("入库装卸费用(元)"),
    dataIndex: "stock_in_handling_amount",
    width: 180,
    ellipsis: true,
  },
  {
    title: T("入库其他费用(元)"),
    dataIndex: "stock_in_expense_amount",
    width: 180,
    ellipsis: true,
  },
  {
    title: T("出库短驳费用(元)"),
    dataIndex: "stock_out_transport_amount",
    width: 180,
    ellipsis: true,
  },
  {
    title: T("出库费用(元)"),
    dataIndex: "stock_out_handling_amount",
    width: 180,
    ellipsis: true,
  },
  {
    title: T("出库其他费用(元)"),
    dataIndex: "stock_out_expense_amount",
    width: 180,
    ellipsis: true,
  },
  {
    title: T("仓储费用(元)"),
    dataIndex: "storage_charge_amount",
    width: 100,
    ellipsis: true,
  },
  {
    title: T("总金额(元)"),
    dataIndex: "total_amount",
    width: 100,
    ellipsis: true,
  },
  {
    title: T("操作"),
    dataIndex: "action",
    fixed: "right",
    width: 100,
    scopedSlots: { customRender: "action" },
  },
];
